import {Col, Flex, Row, Typography} from "antd";
import React from "react";
import {useTranslations} from "next-intl";
import {ThemeColors} from "@/src/entities/colors";
import Icon from "@ant-design/icons";
import Swimming from "@/public/assets/svg/swimming2.svg"
import Accomodation from "@/public/assets/svg/door-handle.svg"
import Towel from "@/public/assets/svg/towel.svg"
import Parking from "@/public/assets/svg/parking.svg"
import Attraction from "@/public/assets/svg/tennis.svg"
import CarRental from "@/public/assets/svg/auto.svg"
import Food from "@/public/assets/svg/restaurant.svg"
import Wifi from "@/public/assets/svg/wifi.svg"
import {ThemeService} from "@/src/services/theme";

const ServicesComponent = () => {

    const localization = useTranslations('services');
    const themeColors = ThemeService.getThemeColors()

    enum ServiceType {
        ACCOMODATION = "accomodation",
        TOWEL = "towel",
        PARKING = "parking",
        SWIMMING = "swimming",
        ATTRACTION = "attraction",
        WIFI = "wifi",
        CAR_RENTAL = "carRental",
        FOOD = "food"
    }

    const getTitle = (type: ServiceType) => {
        return localization(`${type}.title`)
    }

    const getText = (type: ServiceType) => {
        return localization(`${type}.text`)
    }

    const getImage = (type: ServiceType) => {
        switch (type) {
            case ServiceType.ACCOMODATION:
                return Accomodation
            case ServiceType.TOWEL:
                return Towel
            case ServiceType.SWIMMING:
                return Swimming
            case ServiceType.PARKING:
                return Parking
            case ServiceType.ATTRACTION:
                return Attraction
            case ServiceType.CAR_RENTAL:
                return CarRental
            case ServiceType.FOOD:
                return Food
            case ServiceType.WIFI:
                return Wifi
        }
    }

    const getServices = () => {
        return [
            ServiceType.ACCOMODATION,
            ServiceType.TOWEL,
            ServiceType.PARKING,
            ServiceType.SWIMMING,
            ServiceType.ATTRACTION,
            ServiceType.WIFI,
            ServiceType.CAR_RENTAL,
            ServiceType.FOOD
        ]
    }


    return (
        <div style={{padding: 24}}>
            <Flex vertical gap={16} justify={"center"} align={"center"} style={{margin: "60px 0 40px 0", padding: "0 24px", textAlign: "center"}}>
                <Typography.Title level={2} className={"sectionTitle"}>{localization("title")}</Typography.Title>
                <Typography.Text  style={{fontSize: 16, color: "#444"}}>{localization("text")}</Typography.Text>
            </Flex>
            <Row gutter={[64, { xs: 16, sm: 24, md: 24, lg: 32 }]}>
                {(() => {
                    return getServices().map((value, index) => {
                        return  <Col xs={24} sm={12} md={8} key={index}>
                            <Flex vertical gap={16}>
                                <Icon component={getImage(value)} style={{margin: "0 auto", fontSize: 64, color: themeColors.menuBarColor}} />
                                <Typography.Title level={3} style={{fontSize: 18, textAlign: "center", color: "#444", marginBottom: 0}}>{getTitle(value)}</Typography.Title>
                                <div style={{backgroundColor: themeColors.menuBarColor, width: 50, height: 2, margin: "0 auto"}} />
                                <Typography.Paragraph style={{fontSize: 14, textAlign: "center", color: "#444"}}>{getText(value)}</Typography.Paragraph>
                            </Flex>
                        </Col>
                    })
                })()}
            </Row>

        </div>
    )
}

export default ServicesComponent